"use client";

import BlogItem from "./single/blog-item";
import Link from "next/link";
import { useEffect, useState } from "react";
import { homeApi } from "@/lib/api/home";
import { useTranslation } from "react-i18next";
import { ifArabic, getLocalizedPath } from "@/utils/language";
import { useLanguage } from "@/app/[lang]/client/language-context";
import { ArrowIcons } from "../svg";

export default function BlogOne({ cpd }: { cpd?: boolean }) {
  const [listNews, setListNews] = useState<any[]>([]);
  const { t } = useTranslation();
  const { language } = useLanguage();

  const fetchAllNews = async () => {
    try {
      const news = (await homeApi.getNews(cpd ? "cpd" : "All")) as any;
      setListNews(news);
    } catch (error) {
      console.error("Error fetching news:", error);
    }
  };

  useEffect(() => {
    fetchAllNews();
  }, []);

  return (
    <section className="blog-area white-bg pt-70 pb-70">
      <div className="container">
        <div className="align-items-center d-flex justify-content-between mb-50">
          <div className="tp-event-section wow fadeInUp" data-wow-delay=".2s">
            <div className="tp-section">
              <h2 className="tp-section-title">
                {t("blog_latest")} <span>{t("blog_news")} </span>
              </h2>
            </div>
          </div>
          {!cpd && (
            <div className="tp-event-btn text-md-end">
              <Link
                aria-label="View All News"
                className="tp-btn"
                href={getLocalizedPath("/news", language)}
              >
                {t("blog_view_all_news")}
                <span>
                  {ifArabic(
                    <ArrowIcons.LeftArrow />,
                    <ArrowIcons.RightArrow />
                  )}
                </span>
              </Link>
            </div>
          )}
        </div>
        <div className="row">
          {listNews.slice(0, 3).map((blog) => (
            <div key={blog.Id} className="col-lg-4">
              <BlogItem blog={blog} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
